import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgTrustWalletIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    viewBox="0 0 65 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath="url(#trust-wallet-icon_svg__a)">
      <path
        d="M32.4 64c17.673 0 32-14.327 32-32 0-17.673-14.327-32-32-32C14.727 0 .4 14.327.4 32c0 17.673 14.327 32 32 32Z"
        fill="#3375BB"
      />
      <path
        d="M32.627 14c6.324 5.282 13.576 4.956 15.648 4.956-.453 30.038-3.907 24.081-15.648 32.504C20.885 43.037 17.453 48.994 17 18.956c2.05 0 9.303.326 15.627-4.956Z"
        stroke="#fff"
        strokeWidth={4}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="trust-wallet-icon_svg__a">
        <path fill="#fff" transform="translate(.4)" d="M0 0h64v64H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTrustWalletIcon;
